import { changeCheckboxStatus } from '@engine/lib/utility/change_checkbox_status';
import { showHideRefundEmail } from '@engine/features/show_hide_refund_email';

function toggleAllCheckboxes(id) {
  var checkboxes = $(id).find(':checkbox');

  if (checkboxes.prop('checked') === true) {
    checkboxes.prop('checked', false).trigger('change'); // Change avs, account verificatio, cashu and paysafecard checkboxes

    if (id === '#required_api_params') {
      changeCheckboxStatus(['transaction_type_account_verification', 'transaction_type_cashu', 'transaction_type_paysafecard', 'transaction_type_sofort', 'transaction_type_ppro', 'transaction_type_neteller', 'transaction_type_abn_ideal', 'transaction_type_webmoney', 'transaction_type_p24', 'transaction_type_sdd_sale', 'transaction_type_sdd_recurring_sale', 'transaction_type_sdd_init_recurring_sale', 'transaction_type_wechat'], false);
    }
  } else {
    checkboxes.not(':disabled').prop('checked', true).trigger('change');
    /*
     * Change avs, account verificatio, cashu, paysafecard
     * and sdd transactions checkboxes
     */

    if (id === '#supported_transaction_types') {
      changeCheckboxStatus(['required_api_param_address1', 'required_api_param_city', 'required_api_param_zip_code', 'required_api_param_customer_email', 'required_api_param_remote_ip', 'required_api_param_country', 'required_api_param_first_name', 'required_api_param_last_name', 'required_api_param_usage'], true);
    }
  }

  if (id === '#supported_features') {
    showHideRefundEmail();
  }
}

function listenForCheckboxesLabelClick() {
  var checkbox_ids = ['supported_features', 'supported_transaction_types', 'required_api_params', 'enabled_terminals', 'risk_filters'];
  $.each(checkbox_ids, function (index, value) {
    var label = 'label[for="' + value + '"]';
    $('body').on('click', label, function () {
      toggleAllCheckboxes('#' + value);
    });
  });
}

function listenForTrxCategoryLabelStateChange() {
  $('#supported_transaction_types label.select_all').on('click', function () {
    var state = $(this).data('state') || false;
    $(this).data('state', !state);
    $(this).closest('.category-container').find(':checkbox:enabled[name="transaction_types[]"]').prop('checked', $(this).data('state')).trigger('change');
  });
}

function listenForCheckboxesCountryStateChange() {
  var countryCheckbox = $('#required_api_param_country');
  var stateCheckbox = $('#required_api_param_state');
  countryCheckbox.on('change', function () {
    if (countryCheckbox.prop('checked') === false) {
      stateCheckbox.prop('checked', false);
    }
  });
  stateCheckbox.on('change', function () {
    if (stateCheckbox.prop('checked') === true) {
      countryCheckbox.prop('checked', true);
    }
  });
}

export { listenForCheckboxesLabelClick, listenForTrxCategoryLabelStateChange, listenForCheckboxesCountryStateChange };